export const getSearch = ({filters}) => filters.search;
export const getFilters = ({filters}) => filters.other;